import Axios from "axios";
import { makeAutoObservable } from "mobx";

import { INTERFACE } from "../utils/getting";
import { AsyncTo, EncaInterface, GetQueryParam, SetQueryParam } from "../utils/setting";

class LadderStore {
    constructor() {
        makeAutoObservable(this);
    }
	// 英雄
	hero = null
	heroLoading = false
	getHero = async(btag, hero, server) => {
		this.hero = null;
		this.heroLoading = true;
		const promise = Axios.get(`${INTERFACE.ladderHero}/${btag}/${server}/${hero}`);
		const [err1, res1] = await AsyncTo(promise);
		const [err2, res2] = await EncaInterface({
			name: "ladderEquip",
			params: {
				battleTag: btag,
				heroId: hero,
				serverType: server
			}
		});
		this.heroLoading = false;
		if (!err1 && res1 && res1.status === 200 && res1.data && res1.data.info) {
			if (!err2 && res2 && res2.info) {
				delete res2.info.uploadUserInfo;
				if (!res2.info.offHand && res2.info.mainHand && res2.info.mainHand.type.twoHanded) {
					res2.info.offHand = { ...res2.info.mainHand };
					res2.info.offHand.slots = "offHand";
					res2.info.offHand.twoHandedClass = true;
				}
				res1.data.info.items = res2.info;
			} else {
				Object.keys(res1.data.info.items).forEach(v => (res1.data.info.items[v].isHover = false));
			}
			this.hero = res1.data.info;
		}
	}
	// 配置
	option = null
	optionIndex = {
		ci: "",
		ji: "",
		mi: "",
		si: ""
	}
	optionLoading = false
	getOption = async () => {
		this.option = null;
		this.optionLoading = true;
		const [err, res] = await EncaInterface({ name: "ladderOption" });
		this.optionLoading = false;
		if (!err && res && res.info) {
			const { modeList, mysticTypeList, seasonList, serverTypeList } = res.info;
			this.option = {
				job: mysticTypeList,
				mode: modeList,
				season: seasonList,
				server: serverTypeList
			};
			this.optionIndex = {
				ci: (seasonList.find(v => v.type === "现赛季") || {}).code || "",
				ji: (mysticTypeList.find(v => v.type === "单人") || {}).code || "0",
				mi: (modeList.find(v => v.type === "普通") || {}).code || "0",
				si: (serverTypeList.find(v => v.type === "全部") || {}).code || ""
			};
		}
	}
	// 排行
	ranking = []
	rankingIndex = 0
	rankingMaxIndex = 0
	rankingLoading = false
	getRanking = async(index = +GetQueryParam("page"), opt = {}) => {
		this.ranking = [];
		this.rankingLoading = true;
		this.optionIndex = Object.assign({}, this.optionIndex, opt);
		const { ci, ji, mi, si } = this.optionIndex;
		const promise = Axios.get(`${INTERFACE.ladderRanking}/${50 * index}/50`, {
			params: {
				modeType: mi,
				mysticType: ji,
				season: ci,
				serverType: si
			}
		});
		const [err, res] = await AsyncTo(promise);
		this.rankingLoading = false;
		if (!err && res && res.status === 200 && res.data) {
			const { info, totalSize } = res.data;
			this.ranking = info || [];
			this.rankingIndex = index;
			this.rankingMaxIndex = totalSize >= 2000 ? 39 : Math.ceil(totalSize / 50) - 1;
			SetQueryParam({ page: index });
		}
	}
	// 记录
	record = null
	recordLoading = false
	getRecord = async() => {
		this.record = null;
		this.recordLoading = true;
		const [err, res] = await EncaInterface({ name: "ladderRecord" });
		this.recordLoading = false;
		if (!err && res && res.info) {
			this.record = res.info;
		}
	}
	// 目标
	target = null
	targetLoading = false
	getTarget = async(btag = "") => {
		this.target = null;
		this.targetLoading = true;
		const [err, res] = await EncaInterface({
			name: "ladderTarget",
			params: { battleTag: btag }
		});
		this.targetLoading = false;
		if (!err && res && res.info) {
			this.target = res.info;
		}
	}
	// 其他
	syncData = async() => {
		await EncaInterface({ name: "ladderSync" });
	}
}

const Ladder = new LadderStore()
export default Ladder;